import { enableProdMode, importProvidersFrom } from '@angular/core';
import { environment } from './environments/environment';
import { AppComponent } from './app/app.component';
import { withInterceptorsFromDi, provideHttpClient } from '@angular/common/http';
import { ModalModule } from 'ngx-bootstrap/modal';
import { routes } from './app/app-routing.module';
import { provideAnimations } from '@angular/platform-browser/animations';
import { bootstrapApplication } from '@angular/platform-browser';
import { provideRouter } from '@angular/router';
import '@angular/compiler'; 
import { RECAPTCHA_V3_SITE_KEY } from "ng-recaptcha-2";
import { environment as env } from 'src/environments/environment';

if (environment.production) {
  enableProdMode();
}

bootstrapApplication(AppComponent, {
    providers: [
      importProvidersFrom(ModalModule.forRoot()),
      provideAnimations(),
      provideHttpClient(withInterceptorsFromDi()),
      provideRouter(routes),
      { provide: RECAPTCHA_V3_SITE_KEY, useValue: env.recaptchaSiteKeyV3 }
    ]
})
  .catch(err => console.error(err));
